import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { GetFeedback } from '../../services/feedback.service';
import { customStyles, FEEDBACK_STATUSES } from "../../utils/constants";
import moment from "moment";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { toast } from "react-toastify";
import { Button, Col, Dropdown, DropdownButton, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import { MenuDots, SearchIcon } from "../../components/SvgIcons";
import DataTable from "react-data-table-component";
import BarLoader from "react-spinners/BarLoader";

function Feedback(props) {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const typingTimeoutRef = useRef(null);

    useEffect(() => {
        getFeedback();
    }, [keyword, page, perPage, status])

    const getFeedback = async () => {
        setLoading(true)
        try {
            const result = await GetFeedback(keyword, page, perPage, status);
            if (result?.status) {
                if (result?.data?.data) {
                    const rowData = [];
                    const startIndex = (page - 1) * perPage;
                    setPage(result?.data?.pagination?.currentPage)
                    setTotalRows(result?.data?.pagination?.total);
                    result?.data?.data?.forEach((dt, index) => {
                        rowData.push({
                            serialNumber: startIndex + index + 1,
                            id: dt._id || '-',
                            // name: dt?.name || '-',
                            // email: dt?.email || '-',
                            message: dt?.feedback || '-',
                            status: dt?.status || FEEDBACK_STATUSES.UNREAD,
                            createdAt: dt?.createdAt ? moment(dt?.createdAt).fromNow() : '-',
                            updatedAt: dt?.updatedAt ? moment(dt?.updatedAt).fromNow() : '-',
                        });
                    })
                    setRows(rowData);
                }
            } else {
                setRows([]);
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false)
        }
    }

    const handleError = (error) => {
        if (error.response?.status === 401) {
            EmptyLocalStorage()
            history.push('/');
        } else if (error.response?.status === 404) {
            setRows([]);
        } else {
            toast.error(error.response?.data?.message || "An error occurred");
        }
    }

    const columns = [
        {
            id: 'serialNumber',
            name: 'S.No',
            maxWidth: '60px',
            center: true,
            sortable: false,
            selector: rowData => rowData.serialNumber,
        },
        // {
        //     id: 'name',
        //     name: 'Name',
        //     maxWidth: '160px',
        //     sortable: true,
        //     selector: rowData => rowData.name,
        // },
        // {
        //     id: 'email',
        //     name: 'Email',
        //     minWidth: '180px',
        //     maxWidth: '240px',
        //     selector: rowData => rowData.email,
        // },
        {
            id: 'message',
            name: 'Message',
            sortable: true,
            grow: false,
            minWidth: '300px',
            maxWidth: '500px',
            selector: rowData => rowData.message,
        },
        {
            id: 'status',
            name: 'Status',
            grow: false,
            center: true,
            selector: rowData => {
                const statusText = Object.keys(FEEDBACK_STATUSES).find(key => FEEDBACK_STATUSES[key] === rowData.status) || 'Unknown';
                return statusText.replace('_', ' ');
            },
        },
        {
            id: 'updatedAt',
            name: 'Last Updated',
            grow: false,
            center: true,
            selector: rowData => rowData.updatedAt,
        },
        {
            id: 'createdAt',
            name: 'Received',
            grow: false,
            center: true,
            selector: rowData => rowData.createdAt,
        },
        {
            id: 'action',
            name: 'Action',
            center: true,
            cell: rowData => userActions(rowData)
        },
    ];

    const filterStatus = async (value) => {
        setStatus(value)
    }

    const onView = (data) => {
        history.push('/feedback/view-feedback/' + data.id, {
            data: data
        });
    }

    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onView(data)}>View</Dropdown.Item>
            </DropdownButton>
        )
    }

    const handleKeyUp = (e) => {
        clearTimeout(typingTimeoutRef.current);

        const value = e.target.value;
        if (value.length > 2) {
            typingTimeoutRef.current = setTimeout(() => {
                setKeyword(value);
            }, 500);
        } else {
            setKeyword(null);
        }
    };

    return (
        <div className={"feedbackPage"}>
            <h1 className="page-heading">Feedback</h1>
            <hr />
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={9} lg={9} xl={9}></Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Form.Group className={"mb-3"} controlId="status">
                            <Form.Select 
                                className='formselect' 
                                aria-label="status"
                                onChange={(e) => filterStatus(e.target.value)}
                                value={status}
                            >
                                <option value="">Show All</option>
                                <option value={FEEDBACK_STATUSES.UNREAD}>Unread</option>
                                <option value={FEEDBACK_STATUSES.ADDRESSED}>Addressed</option>
                                <option value={FEEDBACK_STATUSES.SAVED_LATER}>Saved for Later</option>
                                <option value={FEEDBACK_STATUSES.IGNORE}>Ignored</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
            <div className="theme-dataGrid products-dataGrid">
                <DataTable
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#41D2D2'} loading={loading} css={'marginTop: 10px'}
                        height={'4'} width={'100%'} />}
                />
            </div>
        </div>
    )
}

export default Feedback;